import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51f2b8ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "landscape" }
const _hoisted_4 = { class: "video" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "kv" }
const _hoisted_9 = ["srcset"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))

import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useHome, useModal, useInfo } from '@/store';
import { isPC, checkDirection } from '@/hooks/useCheck';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
type ActiveSwiperBtnType = 'next' | 'prev' | null;

export default /*#__PURE__*/_defineComponent({
  __name: 'Milestones',
  setup(__props) {

_useCssVars(_ctx => ({
  "75ea2a64": (_unref(bg).pc),
  "7c01e6da": (_unref(bg).mobile),
  "390c1f46": (_unref(mask).pc),
  "944da3e8": (_unref(mask).mobile),
  "2f23aed0": (_unref(arrow).pc),
  "78028aaa": (_unref(arrowActive).pc),
  "1bf57ff6": (_unref(dotPagination).mobile),
  "2033f5da": (_unref(coverFrame).pc),
  "5fc0107c": (_unref(coverFrame).mobile),
  "72c9cf77": (_unref(kvFrame).pc),
  "4d8ff026": (_unref(kvFrame).mobile),
  "b76458fa": (_unref(playButton).pc),
  "42fd1d1d": (_unref(playButtonActive).pc)
}))

const { milestones } = storeToRefs(useHome());
const { openModal, setCover, setYoutube, playVideo } = useModal();
const modules = [Navigation, Pagination];
const navigation = {
  nextEl: '.milestones .swiper-button-next',
  prevEl: '.milestones .swiper-button-prev',
};
const pagination = {
  el: '.swiper-pagination',
  clickable: true,
  renderBullet: function (index: number, className: string) {
    return `<span class="${className}"></span>`;
  },
};
const activeBtnType = ref<ActiveSwiperBtnType>(null);
const updateActiveSwiperBtnType = (type: ActiveSwiperBtnType) => {
  activeBtnType.value = type;
};
const { getImg } = useInfo();
const bg = computed(() => ({
  pc: `url(${getImg('home_pc_milestones_bg')})`,
  mobile: `url(${getImg('home_mobile_milestones_bg')})`,
}));
const mask = computed(() => ({
  pc: `url(${getImg('home_pc_milestones_bottom_mask')})`,
  mobile: `url(${getImg('home_mobile_milestones_bottom_mask')})`,
}));
const arrow = computed(() => ({
  pc: `url(${getImg('home_pc_milestones_arrow')})`,
}));
const arrowActive = computed(() => ({
  pc: `url(${getImg('home_pc_milestones_arrow_active')})`,
}));
const dotPagination = computed(() => ({
  mobile: `url(${getImg('home_mobile_pagination')})`,
}));
const coverFrame = computed(() => ({
  pc: `url(${getImg('home_pc_cover_frame')})`,
  mobile: `url(${getImg('home_mobile_cover_frame')})`,
}));
const kvFrame = computed(() => ({
  pc: `url(${getImg('home_pc_kv_frame')})`,
  mobile: `url(${getImg('home_mobile_kv_frame')})`,
}));
const playButton = computed(() => ({
  pc: `url(${getImg('home_pc_play')})`,
}));
const playButtonActive = computed(() => ({
  pc: `url(${getImg('home_pc_play_active')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(milestones).length > 0)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass([
      'milestones',
      {
        pc: _unref(isPC),
      },
    ])
      }, [
        _createVNode(_unref(Swiper), {
          navigation: navigation,
          pagination: pagination,
          modules: modules,
          allowTouchMove: !_unref(isPC),
          dir: _unref(checkDirection)
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(milestones), (milestone, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(milestone.title), 1),
                  _createElementVNode("article", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                          src: milestone.videoCover
                        }, null, 8, _hoisted_5),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (
                  _unref(openModal)(true),
                    _unref(setCover)(milestone.videoCover),
                    _unref(setYoutube)(milestone.youtubeId),
                    _unref(playVideo)(true)
                )
                        }, null, 8, _hoisted_6)
                      ]),
                      _createElementVNode("p", {
                        class: "description",
                        innerHTML: milestone.description
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("picture", _hoisted_8, [
                      _createElementVNode("source", {
                        srcset: milestone.kvImageLandscape,
                        media: "(min-width: 751px)"
                      }, null, 8, _hoisted_9),
                      _createElementVNode("img", {
                        src: milestone.kvImagePortrait,
                        alt: ""
                      }, null, 8, _hoisted_10)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createElementVNode("div", {
              class: _normalizeClass([
          'swiper-button-next',
          {
            active: activeBtnType.value === 'next',
          },
        ]),
              onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (updateActiveSwiperBtnType('next'))),
              onTouchend: _cache[1] || (_cache[1] = ($event: any) => (updateActiveSwiperBtnType(null))),
              onTouchcancel: _cache[2] || (_cache[2] = ($event: any) => (updateActiveSwiperBtnType(null)))
            }, null, 34),
            _createElementVNode("div", {
              class: _normalizeClass([
          'swiper-button-prev',
          {
            active: activeBtnType.value === 'prev',
          },
        ]),
              onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (updateActiveSwiperBtnType('prev'))),
              onTouchend: _cache[4] || (_cache[4] = ($event: any) => (updateActiveSwiperBtnType(null))),
              onTouchcancel: _cache[5] || (_cache[5] = ($event: any) => (updateActiveSwiperBtnType(null)))
            }, null, 34),
            _hoisted_11
          ]),
          _: 1
        }, 8, ["allowTouchMove", "dir"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})